<template>
  <slot v-bind="{ viewDocument }">
    <span
      v-bind="attrs"
      @click="viewDocument"
      v-html="link"
    />
  </slot>
  <BaseModal
    ref="modal"
    :width="1000"
    can-click-outside
  >
    <slot name="iframe">
      <iframe :src="doc"></iframe>
    </slot>
  </BaseModal>
</template>

<script setup>
import { ref, useAttrs } from 'vue'

import useVueSlots from '@shared/composables/useVueSlots.js'

import BaseModal from '@shared/components/BaseModal.vue'

const attrs = useAttrs()
const { hasSlot } = useVueSlots(['default', 'iframe'])

/**
 * @link [HTML] Should come from translation file and specify an a tag which references static documents.
 * For example: <a class="a-link" href="#" data-link="/static/us/terms/index.html">Terms and Conditions</a>
 * DataLink should be the path to the static document
 */
defineProps({
  link: {
    type: String,
    default: '',
  },
})

const modal = ref(null)
const doc = ref(null)

const viewDocument = (e) => {
  const { link } = e.target.dataset

  if (link) {
    e.preventDefault()
    doc.value = link
    modal.value.open()
  } else if (hasSlot.value['iframe']) {
    e.preventDefault()
    modal.value.open()
  }
}
</script>

<style lang="scss" scoped>
// Make the modal body fill available height so only the iframe scrolls,
// not the wrapping modal containers (prevents double scrolling).
:deep(.modal-mask__container) {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

:deep(.modal-mask__container--body) {
  flex: 1;
  overflow: hidden;
  max-height: unset;
  padding: 0;
}

iframe {
  border: none;
  width: 100%;
  height: calc(
    100dvh -
      $kds-space-2x - env(safe-area-inset-top) - env(safe-area-inset-bottom)
  );
}
</style>
